module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am495-bdc2dbc979a4fb5510f4237b50143810.jpg";